import { SelectButtonItem } from 'app/components/choose-button/choose-button';
import { i18n } from 'app/i18n';
import { ServiceType } from 'app/pages/order/model/service-type';
import {
    blackWifiImageProps,
    cellTowerImageProps,
    gamingImageProps,
    phoneImageProps,
    tvImageProps,
} from 'app/resources/images';

const serviceTypeMap: Record<ServiceType, SelectButtonItem> = {
    [ServiceType.TV]: {
        text: i18n.page.chooseServiceLocation.tv,
        icon: tvImageProps,
    },
    [ServiceType.INTERNET]: {
        text: i18n.page.chooseServiceLocation.wifi,
        icon: blackWifiImageProps,
    },
    [ServiceType.VOIP]: {
        text: i18n.page.chooseServiceLocation.phone,
        icon: phoneImageProps,
    },
    [ServiceType.TA_VOIP]: {
        text: i18n.page.chooseServiceLocation.phone,
        icon: phoneImageProps,
    },
    [ServiceType.XBOX_ALL_ACCESS]: {
        text: i18n.page.chooseServiceLocation.gaming,
        icon: gamingImageProps,
    },
    [ServiceType.FWA]: {
        text: i18n.page.chooseServiceLocation.fixedWirelessAccess,
        icon: cellTowerImageProps,
    },
};

class ServiceTypeMapper {
    public static toSelectButtonItems = (serviceTypes: string[]): SelectButtonItem[] =>
        Object.values(ServiceType)
            .filter((serviceType) => serviceTypes.includes(serviceType))
            .map((serviceType) => serviceTypeMap[serviceType]);
}

export { ServiceTypeMapper };
